const formatNumber = (value, opts = {}) => {
  if (opts.asPercent) return `${(Number(value || 0)).toFixed(1)}%`;
  return Number(value || 0).toLocaleString();
};

const renderValue = (item) => {
  if (item.render) return item.render(item.value);
  if (typeof item.value === 'string') return item.value;
  return formatNumber(item.value, item);
};

const KpiCards = ({ items = [] }) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
    {items.map((item) => (
      <div key={item.label} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <p className="text-sm text-slate-600">{item.label}</p>
        <p className="text-2xl font-semibold text-slate-900">{renderValue(item)}</p>
        {item.hint && <p className="text-xs text-slate-500">{item.hint}</p>}
      </div>
    ))}
  </div>
);

export default KpiCards;
